package de.oevbs.kunde.kundenportal2.authentication

import dev.fritz2.core.Lenses
import kotlinx.datetime.Clock
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Lenses
@Serializable
data class PortalPrincipal(
    val _id: String = "user",
    val username: String = "",
    val token: String? = null,
    val firstname: String = "",
    val lastname: String = "",
    val cid: String = "",
    val expiresAt: Instant = Instant.DISTANT_PAST,
    val authorities: Set<String> = emptySet()
) {
    companion object

    fun hasAuthority(authority: String): Boolean =
        authority in authorities

    fun hasAuthority(portalAuthority: PortalAuthority): Boolean =
        hasAuthority(portalAuthority.value)

    /**
     * Refines raw token caught from http header into the canonical form for cookie usage.
     * ```
     * // from HTTP:
     *   Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzUxMiJ9.eyJzdWIi...
     * // we only need the pure token and not the whitespace and "Bearer" keyword
     * eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzUxMiJ9.eyJzdWIi...
     * ```
     */
    fun tokenAsCookieValue() = token?.substringAfterLast(" ")
}

/**
 * Convenience-Funktion, um anhand eines [principal]s zu prüfen, ob der Nutzer die gegebene [authority] hat.
 *
 * Dieser Workaround deckt ebenfalls folgende Sonderfälle ab, die sich aus dem alten Portal ergeben:
 *
 * | Fall                                                          | Beschreibung                                                       |
 * |---------------------------------------------------------------|--------------------------------------------------------------------|
 * | Die Authority ist `None`                                      | Der Nutzer hat die Authority ungeachtet des Principals             |
 * | Die Authority ist _nicht_ `None` und der Principal ist `null` | Es wird davon ausgegangen, dass der Nutzer die Authority nicht hat |
 */
fun hasAuthority(principal: PortalPrincipal?, authority: PortalAuthority): Boolean =
    authority == PortalAuthority.None || (principal?.hasAuthority(authority) ?: false)